import React, { FC, useEffect, useState } from "react";
import { itemProp, navbarList } from "../../utils/navbarList";
import { ProSidebar, Menu, MenuItem, SubMenu, SidebarHeader, SidebarContent } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { Link, NavLink } from "react-router-dom";
import { ROLES } from "../../utils/constant";
import { useAppSelector } from "../../hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/pro-regular-svg-icons";
import { useLocation } from "react-router-dom";
import logoimg from "../../assets/img/Racklogo.svg";
import smallLogoImg from "../../assets/img/small_logo.svg";
import decryptData from "../../reusable/decryptData";

const Sidebar = () => {
  const userResponse = useAppSelector((state) => state.user);
  const [collapsed, setCollapsed] = useState(false);
  const { user } = userResponse;
  const [toggled, setToggled] = useState(false);
  const [activeItem, setActiveItem] = useState(() => {
    return localStorage.getItem('activeItem') || 'Dashboard';
  });
  const loginuserdata = decryptData();
  const roleId = loginuserdata?.role_id;

  const location = useLocation();

  useEffect(() => {
    localStorage.setItem('activeItem', activeItem);
  }, [activeItem]);

  const handleToggleSidebar = (value: any) => {
    setToggled(value);
  };

  const onClickMenuIcon = () => {
    setCollapsed(!collapsed);
    localStorage.setItem("Collaped", `${!collapsed}`)
  };

  const Item: FC<{ item: itemProp }> = ({ item }) => {
    const pathname = useLocation().pathname;

    useEffect(() => {

      if (pathname.includes("/verified-issue-summary") || pathname.includes("/verified-issue-details")) {
        document.getElementById("dropdown27")?.classList.add("open");
      } else if (pathname.includes("tpi-inspection-summary") || pathname.includes("tpi") || pathname.includes("compare") || pathname.includes("tpiassignproject")) {
        document.getElementById("dropdown28")?.classList.add("open");
      } else if (pathname.includes("element-summary") || pathname.includes("health-parameter") || pathname.includes("element-stock-insights") || pathname.includes("element-library") || pathname.includes("stock-details") || pathname.includes("rack-type-assignment")) {
        document.getElementById("dropdown29")?.classList.add("open");
      } else if (pathname.includes("licence-summary") || pathname.includes("add-new-licence")) {
        document.getElementById("dropdown4")?.classList.add("open");
      } else if (pathname.includes("subscription-summary") || pathname.includes("subscription-overview") || pathname.includes("subscription-setting")) {
        document.getElementById("dropdown30")?.classList.add("open");
      } else if (pathname.includes("escalation") || pathname.includes("notification-user") || pathname.includes("digitization-data-settings")) {
        document.getElementById("dropdown32")?.classList.add("open");
      } else if (pathname.includes("mhe")) {
        document.getElementById("dropdown16")?.classList.add("open");
      } else if (pathname.includes("create-subscription-plan")) {
        document.getElementById("dropdown30")?.classList.add("open");
      } else if (pathname.includes("edit-licence")) {
        document.getElementById("dropdown4")?.classList.add("open");
      }
    }, []);

    const activeTabAdmin = localStorage.getItem("activeTab");
    useEffect(() => {
      if (activeTabAdmin && location.pathname !== "/escalation-matrix") {
        localStorage.removeItem("activeTab")
      }
    }, [location]);


    return (
      <>
        {
          item.child.length == 0 && item.access_role.includes(parseInt(ROLES[user.role])) && (
            <MenuItem
              icon={item.icon}
              id={item.classname}
              active={location.pathname.includes(`${item.urlCommonWord}`)}
            >
              {item.title}
              <Link to={item.path}
              />
            </MenuItem>
          )
        }
        {
          item.child.length > 0 && item.access_role.includes(parseInt(ROLES[user.role])) && (
            <SubMenu
              title={item.title}
              className="Inner_dropdown"
              icon={item.icon}
              id={`dropdown${item.id}`} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}
            >
              {
                item.child &&
                item.child.map((item: itemProp, index: number) => {
                  return item.access_role.includes(parseInt(ROLES[user.role])) && (
                    <MenuItem
                      active={location.pathname.includes(`${item.urlCommonWord}`)}
                      key={`submenu_${index}`}
                    >
                      {item.title}
                      <Link to={item.path}
                      /></MenuItem>
                  )
                })
              }
            </SubMenu>
          )
        }
      </>
    )
  }

  const CollapsedSidebar: any = localStorage.getItem("Collaped");

  return (
    <div className="sidenav-bar" >
      <div className="logo_div" style={{ width: CollapsedSidebar === "true" ? "60px" : "240px" }}>
        {
          CollapsedSidebar === "true" ? <img src={smallLogoImg} alt="Logo" className="small_logo" /> : <img src={logoimg} alt="Logo" className="full_logo" />
        }
      </div>
      <div className="navbar_heading_div" style={{ left: CollapsedSidebar === "true" ? "100px" : "270px" }}>
        <h2 className="nav_heading">RAMS by iNODE</h2>
      </div>
      <ProSidebar
        collapsed={CollapsedSidebar === "true"}
        toggled={toggled}
        onToggle={handleToggleSidebar}
        breakPoint="sm"
        id="sidenav-bar"
      >
        <SidebarHeader>
          <SidebarHeader style={{ left: CollapsedSidebar === "true" ? "70px" : "251px" }}>
            <div onClick={onClickMenuIcon}>
              <FontAwesomeIcon icon={faBars} />
            </div>
          </SidebarHeader>
        </SidebarHeader>
        <SidebarContent>
          <Menu>
            {navbarList &&
              navbarList.map((value: itemProp, index: number) => (
                <Item item={value} key={index} />
              ))}
          </Menu>
        </SidebarContent>
      </ProSidebar>
    </div>
  );
};

export default Sidebar;
